<nav class="fixed top-0 z-50 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700">
    <div class="px-3 py-3 lg:px-5 lg:pl-3">
      <div class="flex items-center justify-between">
        <div class="flex items-center justify-start rtl:justify-end">      
          <a class="flex ml-12 lg:ml-0">
            <img src="assets/logo.svg" class="h-10 me-3" alt="FlowBite Logo" />
          </a>
        </div>
        
        <div class="flex items-center gap-3">
          <button class="py-1 px-2 font-medium text-gray-500 bg-gray-100 rounded-full border flex gap-1">
            <!-- Green-to-white Gradient Circle Icon -->
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="gray" class="size-6">
            <defs>
            <linearGradient id="greenWhiteGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color:rgb(104, 121, 82);stop-opacity:1" /> <!-- local-color-1 -->
            <stop offset="100%" style="stop-color:rgb(188, 202, 169);stop-opacity:1" /> <!-- local-color-5 -->
            </linearGradient>
            </defs>
            <circle cx="12" cy="12" r="10" stroke="gray" stroke-width="1.5" fill="url(#greenWhiteGradient)"/>
            </svg>
            {{walletAddress | walletAddressFormat}}
            <svg (click)="copyAddress(walletAddress)" class="w-6 h-6 text-gray-500 dark:text-white cursor-pointer" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"/>
            </svg>
            </button>
          <button type="button" class="flex items-center">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd" d="M5 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm-2 9a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1Zm13-6a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z" clip-rule="evenodd" />
              </svg>
              <span class="hidden md:inline-block ms-1" (click)="disconnectMetamask()">Signout</span>                
          </button>
      </div>
      </div>
    </div>
  </nav>
  